/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { ProductSearchFacet } from './ProductSearchFacet';
// @ts-ignore
import {
// @ts-ignore
    ProductSearchFacetFromJSON,
// @ts-ignore
    ProductSearchFacetFromJSONTyped,
// @ts-ignore
    ProductSearchFacetToJSON,
} from './ProductSearchFacet';
// @ts-ignore
import type { Sku } from './Sku';
// @ts-ignore
import {
// @ts-ignore
    SkuFromJSON,
// @ts-ignore
    SkuFromJSONTyped,
// @ts-ignore
    SkuToJSON,
} from './Sku';

/**
 * 
 * @export
 * @interface ProductSearchResponse
 */
export interface ProductSearchResponse {
    /**
     * 
     * @type {number}
     * @memberof ProductSearchResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductSearchResponse
     */
    estimatedTotalCount: number;
    /**
     * 
     * @type {Array<Sku>}
     * @memberof ProductSearchResponse
     */
    items: Array<Sku>;
    /**
     * 
     * @type {Array<ProductSearchFacet>}
     * @memberof ProductSearchResponse
     */
    facets: Array<ProductSearchFacet>;
}

/**
 * Check if a given object implements the ProductSearchResponse interface.
 */
// @ts-ignore
export function instanceOfProductSearchResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "estimatedTotalCount" in value;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "facets" in value;

    return isInstance;
}

// @ts-ignore
export function ProductSearchResponseFromJSON(json: any): ProductSearchResponse {
    return ProductSearchResponseFromJSONTyped(json, false);
}

// @ts-ignore
export function ProductSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductSearchResponse {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'total_count') ? undefined : json['total_count'],
        'estimatedTotalCount': json['estimated_total_count'],
        'items': ((json['items'] as Array<any>).map(SkuFromJSON)),
        'facets': ((json['facets'] as Array<any>).map(ProductSearchFacetFromJSON)),
    };
}

// @ts-ignore
export function ProductSearchResponseToJSON(value?: ProductSearchResponse | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.totalCount,
        'estimated_total_count': value.estimatedTotalCount,
        'items': ((value.items as Array<any>).map(SkuToJSON)),
        'facets': ((value.facets as Array<any>).map(ProductSearchFacetToJSON)),
    };
}

